export const formatText = (value: string) => {
  if (value) {
    value = value.toLowerCase();
    return value.split(' ').map(word => word[0].toUpperCase() + word.slice(1)).join(' ')
  }
}